import { SortStore } from '@move-frontend/utils';
import { FlightSort } from './FlightSort';
export class FlightSortStore extends SortStore {
    constructor() {
        super(FlightSort.byScheduledTimeAndAirport);
    }
}
//# sourceMappingURL=FlightSortStore.js.map